import BaseList from './BaseList';
import HotelData from './HotelData';
import type { HotelListItem } from './HotelData';

/**
 * Wrapper to manage lists of hotels. 
 */
class HotelList extends BaseList<HotelData> {
      
    /**
     * Build from list items from rest response.
     */
    static fromListItems(listItems: HotelListItem[]): HotelList {
        const dataItems: HotelData[] = [];
        
        listItems.forEach((item) => {
              dataItems.push(HotelData.fromListItem(item));
        });
        
        return new HotelList(dataItems);
    }

}

export default HotelList;
